import API from '../api';

export const fetchSessionVideos = async ({
  params: { sessionId },
  signal,
} = {}) => {
  try {
    const response = await API.get(`/aichatbot/session_videos/${sessionId}/`, {
      signal,
      params: {
        page: 1,
        page_size: 100,
      },
    });
    console.log(response);
    return response.data.results;
  } catch (error) {
    console.error('Failed to fetch session videos.', error);
    if (error.name === 'CanceledError') {
      console.log('fetchSessionVideos request canceled');
    } else {
      console.error('Failed to fetch session videos.', error);
    }
    throw error;
  }
};

export const submitResponse = async ({
  params: { sessionId, question, recordedBlob, duration },
} = {}) => {
  const formData = new FormData();
  formData.append('session', sessionId);
  formData.append('question', question.interview_question_uuid);
  formData.append(
    'audio_file',
    recordedBlob,
    `answer_q${question.interview_question_uuid}.webm`,
  );
  if (duration !== undefined && duration !== null) {
    formData.append('duration', duration);
  }

  try {
    const response = await API.post(`/aichatbot/submit_response/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log(response);
    return response.data;
    // console.log("test");
    // return "just a test";
  } catch (error) {
    console.error('Transcription error:', error);
    throw error;
  }
};

export const startRealtimeSession = async ({
  params: { sessionId, interviewQuestionUuid },
} = {}) => {
  try {
    const response = await API.post(`/aichatbot/realtime_session/`, {
      session: sessionId,
      interview_question: interviewQuestionUuid,
    });
    // { realtime: {...}|null, speech: {format, chunks}|null, question: {...} }
    return response.data;
  } catch (error) {
    // Best-effort: a failure here just means the follow-up stays in text
    // mode, so never throw to callers.
    console.error('Failed to start realtime session.', error);
    return null;
  }
};

export const cancelRealtimeSession = async ({
  params: { sessionToken },
} = {}) => {
  try {
    const response = await API.post(`/aichatbot/realtime_session/cancel/`, {
      session_token: sessionToken,
    });
    return response.data;
  } catch (error) {
    // Best-effort, idempotent cancel: failures are swallowed on purpose.
    console.error('Failed to cancel realtime session.', error);
    return null;
  }
};

export const advanceFollowUp = async ({
  params: {
    sessionId,
    interviewQuestionUuid,
    sequence,
    recordedBlob,
    duration,
    regenerate,
    prepare,
  },
} = {}) => {
  const formData = new FormData();
  formData.append('session', sessionId);
  formData.append('interview_question', interviewQuestionUuid);
  if (prepare === true) {
    formData.append('prepare', 'true');
  }
  if (sequence !== undefined && sequence !== null) {
    formData.append('sequence', sequence);
  }
  if (recordedBlob) {
    formData.append(
      'audio_file',
      recordedBlob,
      `followup_q${interviewQuestionUuid}_${sequence}.webm`,
    );
  }
  if (duration !== undefined && duration !== null) {
    formData.append('duration', duration);
  }
  if (regenerate === true) {
    formData.append('regenerate', 'true');
  }

  try {
    const response = await API.post(`/aichatbot/followups/advance/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to advance follow-up.', error);
    throw error;
  }
};

export const fetchFollowUpResponses = async ({
  params: { sessionId, interviewQuestionUuid },
  signal,
} = {}) => {
  try {
    const response = await API.get(`/aichatbot/followup_responses/`, {
      signal,
      params: {
        session: sessionId,
        page: 1,
        page_size: 100,
        ...(interviewQuestionUuid
          ? { interview_question: interviewQuestionUuid }
          : {}),
      },
    });
    return response.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.log('fetchFollowUpResponses request canceled');
    } else {
      console.error('Failed to fetch follow-up responses.', error);
    }
    throw error;
  }
};

export const fetchSummary = async ({ params: { sessionId }, signal } = {}) => {
  try {
    const response = await API.get(
      `/aichatbot/generate_summary/${sessionId}/`,
      {
        signal,
      },
    );
    console.log(response);
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg =
      err.response?.data?.error ||
      err.response?.data?.detail ||
      'Failed to fetch sessions.';
    return {
      success: false,
      error: errorMsg,
    };
  }
};

export const getSessionIntroOutroVideoUrls = ({
  params: { uuid } = {},
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/interviews/sessions/${uuid}/get_intro_outro_video_urls`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
